/* eslint-disable */
// src/services/visitTransactionService.js

import axios from "services/axiosConfig";

const API_URL = "/api/visit-transaction";

const COLLECTION_ERROR_MESSAGES_BY_CODE = {
  COLLECTION_TRAGAMONEDA_NO_FORMULA_REQUIRES_MONEY:
    "La tragamonedas sin formula debe cargarse por dinero acumulado.",
  COLLECTION_TRAGAMONEDA_NO_FORMULA_REQUIRES_NET_MONEY:
    "La tragamonedas sin formula debe cargarse por dinero neto.",
  COLLECTION_TRAGAMONEDA_FORMULA_REQUIRES_CREDITS:
    "La tragamonedas con formula debe cargarse por creditos acumulados.",
  COLLECTION_TRAGAMONEDA_FORMULA_REQUIRES_NET_CREDITS:
    "La tragamonedas con formula debe cargarse por creditos netos.",
  COLLECTION_SLOT_NOT_COLLECTIBLE_IN_CURRENT_VISIT:
    "Una de las tragamonedas ya no es recaudable en esta visita.",
  COLLECTION_SLOT_INSERTED_SAME_DAY_NOT_COLLECTIBLE:
    "Una de las tragamonedas fue ingresada el mismo dia de la visita y no es recaudable.",
  COLLECTION_MACHINE_NOT_ACTIVE:
    "Una de las máquinas ya no está activa para guardar la recaudación.",
  COLLECTION_ACTIVE_MACHINE_TYPE_INVALID:
    "La configuración activa de una máquina ya no es válida para esta recaudación.",
  COLLECTION_MACHINE_CONFIG_NOT_FOUND:
    "La máquina no pertenece al conjunto recaudable esperado para esta visita.",
  PAYLOAD_MACHINE_SET_MISMATCH:
    "Las máquinas enviadas ya no coinciden con las recaudables actuales del local.",
  COLLECTION_DRAFT_NOT_FOUND:
    "El borrador de recaudación ya no existe.",
  COLLECTION_DRAFT_NOT_IN_PROCESS:
    "La recaudación ya no está en proceso.",
  COLLECTION_DRAFT_HAS_PENDING_MACHINES:
    "Todavía hay máquinas pendientes para finalizar la recaudación.",
  COLLECTION_DRAFT_MACHINE_SET_MISMATCH:
    "Las máquinas guardadas ya no coinciden con las recaudables actuales del local.",
  COLLECTION_DRAFT_ALREADY_COMPLETE:
    "La recaudación ya fue finalizada.",
  COLLECTION_DRAFT_CANNOT_CANCEL_COMPLETE:
    "No se puede cancelar una recaudación ya finalizada.",
  COLLECTION_DRAFT_DATE_CHANGE_REQUIRES_RESET:
    "Cambiar la fecha reiniciará las máquinas ya cargadas del borrador.",
  VISIT_NOT_FOUND: "Recaudación no encontrada.",
  VISIT_WITH_COLLECTION_NOT_FOUND: "Datos de recaudación no encontrados.",
  VISIT_COLLECTION_KIND_NOT_EDITABLE:
    "La visita no es una recaudación editable.",
  VISIT_STATUS_NOT_EDITABLE:
    "Solo se pueden editar recaudaciones completas.",
  ONLY_LATEST_VISIT_EDITABLE:
    "Solo se puede editar la última recaudación del local.",
  VISIT_MACHINE_NOT_FOUND:
    "La máquina histórica de la recaudación no existe.",
  VISIT_MACHINE_NOT_IN_VISIT:
    "La máquina histórica no pertenece a esta recaudación.",
  COLLECTION_DATE_INVALID: "La fecha de recaudación es inválida.",
  COLLECTION_DATE_BEFORE_LAST_LOCAL_MACHINE_FINISH:
    "La recaudación no puede realizarse antes del último egreso de una máquina del local.",
  COLLECTION_DATE_BEFORE_MIN: "La fecha de recaudación es anterior al mínimo permitido.",
  COLLECTION_DATE_AFTER_MAX: "La fecha de recaudación es posterior al máximo permitido.",
  COLLECTION_EDIT_DATE_UNSAFE_HISTORICAL_CONTEXT:
    "No se puede cambiar la fecha porque cruza cambios históricos del local o de las máquinas.",
  COLLECTION_EDIT_DATE_CROSSES_LOCAL_MACHINE_CHANGE:
    "No se puede cambiar la fecha porque en esa fecha la máquina tenía otra configuración.",
  COLLECTION_EDIT_DATE_CROSSES_PROFIT_PERCENTAGE_CHANGE:
    "No se puede cambiar la fecha porque en esa fecha correspondía otro porcentaje de ganancia.",
  COLLECTION_EDIT_DATE_COUNTER_CONTEXT_CHANGED:
    "No se puede cambiar la fecha porque cambia la configuración o el ciclo de contadores.",
  COLLECTION_EDIT_DATE_DUPLICATED_FOR_LOCAL:
    "No se puede cambiar la fecha porque ya existe otra recaudación del local en ese día.",
  COLLECTION_EDIT_DATE_BEFORE_PREVIOUS_COLLECTION:
    "No se puede cambiar la fecha porque debe ser posterior a la recaudación anterior del local.",
};

export function getVisitTransactionSaveErrorInfo(error) {
  const status = Number(error?.response?.status);
  const code = error?.response?.data?.code ?? null;
  const backendMessage =
    error?.response?.data?.error ??
    error?.response?.data?.message ??
    null;

  return {
    status: Number.isFinite(status) ? status : null,
    code,
    message:
      COLLECTION_ERROR_MESSAGES_BY_CODE[code] ||
      backendMessage ||
      "Error guardando recaudación.",
  };
}

class VisitTransactionService {
  static normalizeVisitTransactionListResponse(data) {
    if (Array.isArray(data)) {
      const rows = data.map((r) => ({
        ...r,
        Date: r.DateTime,
        DateLabel: r.DateUY && r.TimeUY ? `${r.DateUY} ${r.TimeUY}` : null,
      }));
      return {
        rows,
        pagination: {
          page: 1,
          pageSize: rows.length,
          totalRows: rows.length,
          totalPages: rows.length > 0 ? 1 : 0,
          hasNextPage: false,
          hasPreviousPage: false,
        },
      };
    }

    const rawRows = Array.isArray(data?.rows) ? data.rows : [];
    const rows = rawRows.map((r) => ({
      ...r,
      Date: r.DateTime,
      DateLabel: r.DateUY && r.TimeUY ? `${r.DateUY} ${r.TimeUY}` : null,
    }));
    const rawPagination = data?.pagination || {};
    const totalRows = Number(rawPagination.totalRows ?? rows.length ?? 0);
    const pageSize = Number(rawPagination.pageSize ?? rows.length ?? 10);
    const totalPages =
      Number(rawPagination.totalPages) ||
      (pageSize > 0 ? Math.ceil(totalRows / pageSize) : 0);

    return {
      rows,
      pagination: {
        page: Number(rawPagination.page ?? 1),
        pageSize,
        totalRows,
        totalPages,
        hasNextPage:
          typeof rawPagination.hasNextPage === "boolean"
            ? rawPagination.hasNextPage
            : Number(rawPagination.page ?? 1) < totalPages,
        hasPreviousPage:
          typeof rawPagination.hasPreviousPage === "boolean"
            ? rawPagination.hasPreviousPage
            : Number(rawPagination.page ?? 1) > 1,
      },
    };
  }

  static async getTodayCollectionStatusByLocal(localId) {
    try {
      const response = await axios.get(`${API_URL}/today-by-local/${localId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener el estado de recaudación de hoy para local ${localId}:`, error);
      throw error;
    }
  }

  static async startOrResumeCollectionDraft(localId) {
    try {
      const response = await axios.post(`${API_URL}/start-or-resume`, { localId });
      return response.data;
    } catch (error) {
      console.error(`Error al iniciar o retomar recaudación del local ${localId}:`, error);
      throw error;
    }
  }

  static async getCollectionDateBounds(localId, { visitId = null } = {}) {
    try {
      const params = {};
      if (visitId != null) params.visitId = visitId;
      const response = await axios.get(`${API_URL}/collection-date-bounds/${localId}`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener límites de fecha de recaudación para local ${localId}:`, error);
      throw error;
    }
  }

  static async getCollectionEditSafeDateBounds(visitId) {
    try {
      const response = await axios.get(`${API_URL}/${visitId}/edit-date-bounds`);
      return response.data || null;
    } catch (error) {
      console.error("Error al obtener límites seguros de edición de fecha:", error);
      throw error;
    }
  }

  static async finalizeVisitDraft(visitId, payload) {
    try {
      const response = await axios.post(`${API_URL}/${visitId}/finalize-draft`, payload);
      return response.data;
    } catch (error) {
      console.error("Error al finalizar borrador de recaudación:", error);
      throw error;
    }
  }

  static async getDraftProgress(visitId) {
    try {
      const response = await axios.get(`${API_URL}/${visitId}/progress`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener progreso del borrador ${visitId}:`, error);
      throw error;
    }
  }

  static async saveDraftMachine(visitId, localMachineId, payload) {
    try {
      const response = await axios.put(
        `${API_URL}/${visitId}/machines/${localMachineId}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error al guardar máquina ${localMachineId} del borrador ${visitId}:`,
        error
      );
      throw error;
    }
  }

  static async completeDraft(visitId) {
    try {
      const response = await axios.post(`${API_URL}/${visitId}/complete`);
      return response.data;
    } catch (error) {
      console.error(`Error al finalizar borrador ${visitId}:`, error);
      throw error;
    }
  }

  static async deleteDraft(visitId) {
    try {
      const response = await axios.delete(`${API_URL}/${visitId}/draft`);
      return response.data;
    } catch (error) {
      console.error(`Error al cancelar borrador ${visitId}:`, error);
      throw error;
    }
  }

  static async patchDraftDate(visitId, { date, resetPersistedMachines = false } = {}) {
    try {
      const response = await axios.patch(`${API_URL}/${visitId}/draft/date`, {
        date,
        resetPersistedMachines,
      });
      return response.data;
    } catch (error) {
      console.error(`Error al modificar fecha del borrador ${visitId}:`, error);
      throw error;
    }
  }

  static async patchCompletedVisitMachine(visitId, visitMachineId, payload) {
    try {
      const response = await axios.patch(
        `${API_URL}/${visitId}/machines/${visitMachineId}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error al corregir máquina histórica ${visitMachineId} de recaudación ${visitId}:`,
        error
      );
      throw error;
    }
  }

  static async patchCompletedVisitDate(visitId, date) {
    try {
      const response = await axios.patch(`${API_URL}/${visitId}/date`, { date });
      return response.data;
    } catch (error) {
      console.error(`Error al corregir fecha de recaudación ${visitId}:`, error);
      throw error;
    }
  }

  // obtener visitas status complete y sus detalles, ordenable por date, local, total, id asc/desc
  static async getAllVisitTransactions({
    sortBy = "date",
    sortDir = "DESC",
    from,
    to,
    query,
    page = 1,
    pageSize = 10,
  } = {}) {
    try {
      const params = { sortBy, sortDir, page, pageSize };
      if (from) params.from = from;
      if (to) params.to = to;
      if (query) params.query = query;
      const response = await axios.get(`${API_URL}/all-simple`, { params });
      return VisitTransactionService.normalizeVisitTransactionListResponse(response.data);
    } catch (error) {
      console.error("Error al obtener la lista global de recaudaciones:", error);
      return VisitTransactionService.normalizeVisitTransactionListResponse([]);
    }
  }

  // obtener visitas status complete por localId, ordenable por date, total, id asc/desc
  static async getAllVisitTransactionByLocal(
    localId,
    { sortBy = "date", sortDir = "DESC", from, to, query, page = 1, pageSize = 10 } = {}
  ) {
    if (!localId) return VisitTransactionService.normalizeVisitTransactionListResponse([]);
    const response = await axios.get(`${API_URL}/all-by-local/${localId}`, {
      params: {
        sortBy,
        sortDir,
        page,
        pageSize,
        ...(from ? { from } : {}),
        ...(to ? { to } : {}),
        ...(query ? { query } : {}),
      }
    });
    return VisitTransactionService.normalizeVisitTransactionListResponse(response.data);
  }

  // obtener todas las visitMachine de una visit seleccionada
  static async getVisitTransactionDetails(visitId, { localId = null } = {}) {
    try {
      const params = {};
      if (localId != null) params.localId = localId;
      const response = await axios.get(`${API_URL}/details/${visitId}`, { params });
      const d = response.data;
      if (d?.visit) {
        d.visit = {
          ...d.visit,
          Date: d.visit.DateTime,
          DateLabel:
            d.visit.DateUY && d.visit.TimeUY
              ? `${d.visit.DateUY} ${d.visit.TimeUY}`
              : null,
        };
      }
      return d;
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404) return null;

      console.error(
        `Error al obtener detalle de recaudación (visit ${visitId}${localId ? `, local ${localId}` : ""}):`,
        error
      );
      throw error;
    }
  }

  // obtener última visita del local seleccionado
  static async getLastVisitTransactionByLocal(localId) {
    try {
      const response = await axios.get(`${API_URL}/LastVisitByLocal/${localId}`);

      if (response?.status === 204) return null;

      if (!response?.data) return null;

      const d = response.data;
      if (d?.visit) {
        d.visit = {
          ...d.visit,
          Date: d.visit.DateTime,
          DateLabel:
            d.visit.DateUY && d.visit.TimeUY
              ? `${d.visit.DateUY} ${d.visit.TimeUY}`
              : null,
        };
      }
      return d;
    } catch (error) {
      const status = error?.response?.status;

      if (status === 404) return null;

      console.error(
        `Error al obtener la última transacción de visita para local ${localId}:`,
        error
      );
      return null;
    }
  }

  static async getLastCollectionByLocal(localId) {
    try {
      const response = await axios.get(`${API_URL}/LastCollectionByLocal/${localId}`);

      if (response?.status === 204) return null;
      if (!response?.data) return null;

      const d = response.data;
      if (d?.visit) {
        d.visit = {
          ...d.visit,
          Date: d.visit.DateTime,
          DateLabel:
            d.visit.DateUY && d.visit.TimeUY
              ? `${d.visit.DateUY} ${d.visit.TimeUY}`
              : null,
        };
      }
      return d;
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404) return null;

      console.error(
        `Error al obtener la última recaudación para local ${localId}:`,
        error
      );
      return null;
    }
  }

  static async getLastCollectionByMachineInLocal(localMachineId) {
    try {
      const response = await axios.get(`${API_URL}/LastCollectionByMachineInLocal/${localMachineId}`);

      if (response?.status === 204) return null;
      if (!response?.data) return null;

      const d = response.data;
      if (d?.visit) {
        d.visit = {
          ...d.visit,
          Date: d.visit.DateTime,
          DateLabel:
            d.visit.DateUY && d.visit.TimeUY
              ? `${d.visit.DateUY} ${d.visit.TimeUY}`
              : null,
        };
      }
      return d;
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404) return null;

      console.error(
        `Error al obtener la última recaudación de la máquina para LocalMachine ${localMachineId}:`,
        error
      );
      return null;
    }
  }

  // modifica todas las visitMachine de la visita
  // actualiza los totales de la VisitWithCollection
  // modifica Visit con status complete
  static async updateVisitTransactionFull(visitId, payload) {
    try {
      const response = await axios.put(`${API_URL}/${visitId}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error al actualizar recaudación completa:", error);
      throw error;
    }
  }
}

export function getStartOrResumeCollectionDraftErrorInfo(error) {
  const status = Number(error?.response?.status);
  const code = error?.response?.data?.code ?? null;
  const data = error?.response?.data?.data ?? null;
  const backendMessage =
    error?.response?.data?.error ??
    error?.response?.data?.message ??
    null;

  let message = backendMessage || "No se pudo iniciar la recaudación.";
  if (code === "COLLECTION_DAILY_ALREADY_COMPLETE") {
    message = "Ya existe una recaudación completa hoy para este local.";
  } else if (code === "COLLECTION_DAILY_IN_PROCESS_EXISTS") {
    message = "Ya existe una recaudación en proceso hoy para este local.";
  }

  return {
    status: Number.isFinite(status) ? status : null,
    code,
    data,
    message,
  };
}

export default VisitTransactionService;


